import classNames from 'classnames';
import Collapsible from 'react-collapsible';
import Flex, { FlexProps } from '../Flex';
import IcArrow from '../IcArrow';

import './styles.scss';

export interface AppCollapsibleItem {
  title: string;
  content: string;
  inject?: boolean;
  contentAfter?: React.ReactElement;
  contentBefore?: React.ReactElement;
}

export interface AppCollapsibleProps extends FlexProps {
  inject?: boolean;
  titleClassName?: string;
  contentClassName?: string;
  items: AppCollapsibleItem[];
}

export function CollapsibleTrigger({ text, className = '' }) {
  return (
    <Flex align="center" className="w-full font-bold">
      <span className={classNames(className)}>{text}</span>
      <Flex inlineFlex className="ms-auto">
        <IcArrow className="trigger-icon" type="left" size={10} />
      </Flex>
    </Flex>
  );
}

export function AppCollapsible({
  items,
  inject = false,
  titleClassName,
  contentClassName,
}: AppCollapsibleProps) {
  return (
    <Flex direction="column" className="app-collapsible" gap={12}>
      {items.map((item, i) => (
        <Flex key={i} className="app-collapsible-item">
          <Collapsible
            transitionTime={300}
            trigger={(<CollapsibleTrigger className={titleClassName} text={item.title} />)}>

            <Flex className="pt-3" direction="column" gap="0.5rem">
              {item.contentBefore}
              {inject ?
                <div
                  className="w-full text-start"
                  dangerouslySetInnerHTML={{
                    __html: item?.content ?
                      decodeURIComponent(escape(window.atob(item?.content))) :
                      ''
                  }}
                /> :
                <div className={classNames('w-full text-start', contentClassName)}>
                  {item.content}
                </div>
              }
              {item.contentAfter}
            </Flex>

          </Collapsible>
        </Flex>
      ))}
    </Flex>
  );
};

export default AppCollapsible;
